import { apiService } from './api';

export interface ClientAssignment {
  id: string;
  clientId: string;
  adminId: string;
  assignedById: string;
  createdAt: string;
  updatedAt: string;
  client: {
    id: string;
    name: string;
    email: string;
    company?: string;
  };
  admin: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  assignedBy: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface CreateAssignmentRequest {
  clientId: string;
  adminId: string;
}

export interface AssignmentsResponse {
  success: boolean;
  data: ClientAssignment[];
}

export interface AssignmentResponse {
  success: boolean;
  data: ClientAssignment;
  message: string;
}

export interface AssignedClient {
  id: string;
  name: string;
  email: string;
  company?: string;
  country?: string;
  currency: string;
  percentage: number;
  isActive: boolean;
  createdAt: string;
  assignedBy: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  assignedAt: string;
}

export interface AssignedClientsResponse {
  success: boolean;
  data: AssignedClient[];
}

class ClientAssignmentService {
  async getAllAssignments(): Promise<AssignmentsResponse> {
    return await apiService.get<AssignmentsResponse>('/client-assignments');
  }

  async createAssignment(data: CreateAssignmentRequest): Promise<AssignmentResponse> {
    return await apiService.post<AssignmentResponse>('/client-assignments', data);
  }

  async removeAssignment(assignmentId: string): Promise<{ success: boolean; message: string }> {
    return await apiService.delete<{ success: boolean; message: string }>(`/client-assignments/${assignmentId}`);
  }

  async getAssignedClients(adminId: string): Promise<AssignedClientsResponse> {
    return await apiService.get<AssignedClientsResponse>(`/client-assignments/admin/${adminId}`);
  }

  // Utility functions
  formatAdminName(admin: { firstName: string; lastName: string }): string {
    return `${admin.firstName} ${admin.lastName}`;
  }

  formatAssignmentDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
}

export const clientAssignmentService = new ClientAssignmentService();
